import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/sendBox/Toolbar.module_built.css";
const classes = {"sendbox__toolbar-button--active":"weDCCeq_sendbox__toolbar-button--active","sendbox__toolbar-button--with-gradient":"weDCCeq_sendbox__toolbar-button--with-gradient","sendbox__toolbar-button":"weDCCeq_sendbox__toolbar-button","sendbox__toolbar":"weDCCeq_sendbox__toolbar","sendbox__toolbar-button--selected":"weDCCeq_sendbox__toolbar-button--selected","sendbox__toolbar-separator":"weDCCeq_sendbox__toolbar-separator","sendbox__toolbar-button--with-pulse":"weDCCeq_sendbox__toolbar-button--with-pulse"}
export default classes

const _sendbox__toolbar_button__active0 = classes["sendbox__toolbar-button--active"]
export { _sendbox__toolbar_button__active0 as "sendbox__toolbar-button--active" }

const _sendbox__toolbar_button__with_gradient0 = classes["sendbox__toolbar-button--with-gradient"]
export { _sendbox__toolbar_button__with_gradient0 as "sendbox__toolbar-button--with-gradient" }

const _sendbox__toolbar_button0 = classes["sendbox__toolbar-button"]
export { _sendbox__toolbar_button0 as "sendbox__toolbar-button" }

const _sendbox__toolbar0 = classes["sendbox__toolbar"]
export { _sendbox__toolbar0 as "sendbox__toolbar" }

const _sendbox__toolbar_button__selected0 = classes["sendbox__toolbar-button--selected"]
export { _sendbox__toolbar_button__selected0 as "sendbox__toolbar-button--selected" }

const _sendbox__toolbar_separator0 = classes["sendbox__toolbar-separator"]
export { _sendbox__toolbar_separator0 as "sendbox__toolbar-separator" }

const _sendbox__toolbar_button__with_pulse0 = classes["sendbox__toolbar-button--with-pulse"]
export { _sendbox__toolbar_button__with_pulse0 as "sendbox__toolbar-button--with-pulse" }
